require('./overrides.scss')

export default {
  theme: {
    themes: {
      light: {
        primary: '#0b58f3',
        accent: '#0d6efd',
        secondary: '#8A8D93',
        success: '#56ca00',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
        customize: '#0dcaf5',
      },
      dark: {
        primary: '#8d99f8',
        accent: '#0d6efd',
        secondary: '#8A8D93',
        success: '#56CA00',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
        customize: '#0dcaf5',
      },
    },
  },
}
